<template>
	<div class="pop pop-share" :class="{ show: sharePop }">
		<div class="cont">
			<div class="share-image">
				<img :src="$t('shareImg')" alt="" />
			</div>
			<div class="line">
				<div class="icon icon-tw" @click="shareTw"></div>
				<div class="icon icon-fb" @click="shareFb"></div>
				<a class="icon icon-kakao" id="kakaotalk-sharing-btn-tc" href="javascript:;" v-show="curLan == 'tc' "></a>
				<a class="icon icon-kakao" id="kakaotalk-sharing-btn-ja" href="javascript:;" v-show="curLan == 'ja' "></a>
				<a class="icon icon-kakao" id="kakaotalk-sharing-btn-ko" href="javascript:;" v-show="curLan == 'ko' "></a>
				<a class="icon icon-kakao" id="kakaotalk-sharing-btn-en" href="javascript:;" v-show="curLan == 'en' "></a>
				<div class="icon icon-line" @click="shareLine"></div>
			</div>
			<div class="share-bar">
				<div class="share-text">{{ clipText }}</div>
				<div class="btn-copy" :data-clipboard-text="clipText">{{ $t('copy') }}</div>
			</div>
			<a class="pop-close" @click="popClose('share')" href="javascript:void(0);"></a>
		</div>
	</div>
</template>

<script>
	import config from '@/config/config.js'
	import { mapMutations, mapState } from 'vuex'
	import ClipboardJS from 'clipboard'
	import { Toast } from '../lib/toast'
	export default {
		name: 'pop-share',
		mounted() {
			const clipboard = new ClipboardJS('.btn-copy')

			clipboard.on('success', (e) => {
				Toast.showToast(this.$t('copySuccess'), 2000)

				e.clearSelection()
			})

			this.loadRemoteScript('https://t1.kakaocdn.net/kakao_js_sdk/2.4.0/kakao.min.js')
				.then(() => {
					// 远程脚本加载成功后的处理逻辑
					// eslint-disable-next-line
					Kakao.init('ba5b3796c63bdbe6f6971b29c63bdcc6')
					this.initKakaoButton()
				})
				.catch((res) => {
					// 远程脚本加载失败后的处理逻辑
					console.error('load remote js fail', res)
				})
		},
		data() {
			return {
				config
			}
		},
		components: {},
		computed: {
			...mapState(['pop', 'curLan']),
			sharePop() {
				return this.$store.state.pop.share
			},
			clipText() {
				return this.$t('clipText') + ' ' + this.config[this.curLan].shareUrl
			}
		},
		methods: {
			...mapMutations(['popOpen', 'popClose', 'updateState']),
			shareTw() {
				var title = this.config[this.curLan].shareTitle
				var url = this.config[this.curLan].shareUrl
				var desc = this.config[this.curLan].shareDesc
				var encodedText = encodeURIComponent(title + '\n' + desc)
				var encodedURL = encodeURIComponent(url + '?share_platform=twitter')

				window.open('https://twitter.com/intent/tweet?text=' + encodedText + '&url=' + encodedURL)
			},
			shareNaver() {
				var title = this.config[this.curLan].shareTitle
				var desc = this.config[this.curLan].shareDesc
				var url = this.config[this.curLan].shareUrl

				var encodedText = encodeURIComponent(title + '\n' + desc)
				var encodedURL = encodeURIComponent(url + '?share_platform=naver')

				window.open(`https://share.naver.com/web/shareView?url=${encodedURL}&title=${encodedText}`)
			},
			shareKakao() {
				var title = this.config[this.curLan].shareTitle
				var desc = this.config[this.curLan].shareDesc
				var url = this.config[this.curLan].shareUrl

				var openUrl = 'https://story.kakao.com/s/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title + '\n' + desc) + '&display=popup&ref=plugin&src=share_button'

				window.open(openUrl)

				// location.href = "https://story.kakao.com/s/share?url=" +
				// encodeURIComponent(url) +
				// "&text=" + encodeURIComponent(title + "\n" + desc) +
				// "&display=popup&ref=plugin&src=share_button", "line", "height=500, width=750, top=" + (
				// 	document.body.clientHeight / 2 - 250) + ", left=" + (document.body.offsetWidth / 2 - 375) +
				// ", toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no";
			},
			shareLine() {
				var url = this.config[this.curLan].shareUrl

				var encodedURL = encodeURIComponent(url + '?share_platform=line')

				setTimeout(() => {
					window.open(`https://social-plugins.line.me/lineit/share?url=${encodedURL}`)
				}, 200)
			},
			shareFb() {
				var title = this.config[this.curLan].shareTitle
				var desc = this.config[this.curLan].shareDesc
				var url = this.config[this.curLan].shareUrl

				var encodedText = encodeURIComponent(title)
				var encodedDesc = encodeURIComponent(desc)
				var encodedURL = encodeURIComponent(url + '?share_platform=facebook')

				window.open(`https://m.facebook.com/sharer/sharer.php?u=${encodedURL}&description=${encodedDesc}&title=${encodedText}`)
			},
			loadRemoteScript(url) {
				return new Promise((resolve, reject) => {
					const script = document.createElement('script')
					script.src = url
					script.async = true
					script.integrity = 'sha384-mXVrIX2T/Kszp6Z0aEWaA8Nm7J6/ZeWXbL8UpGRjKwWe56Srd/iyNmWMBhcItAjH'
					script.crossOrigin = 'anonymous'
					script.onload = resolve
					script.onerror = reject
					document.body.appendChild(script)
				})
			},
			initKakaoButton() {
				var  createButton = (option)=> {
					console.log('#kakaotalk-sharing-btn-' + option.lan)
					console.log('#kakaotalk:' + option.title)
					console.log('#kakaotalk:' + option.shareImg)
					// eslint-disable-next-line
					Kakao.Share.createDefaultButton({
						container: '#kakaotalk-sharing-btn-' + option.lan,
						objectType: 'feed',
						content: {
							title: option.title,
							description: option.description,
							imageUrl: option.imageUrl,
							link: {
								// Must match the site domain registered in [My Application] > [Platform]
								mobileWebUrl: 'https://www.pandadagames.com/twitchdrops/',
								webUrl: 'https://www.pandadagames.com/twitchdrops/'
							}
						},
						social: {
							likeCount: 286,
							commentCount: 45,
							sharedCount: 845
						},
						buttons: [
							{
								title: this.config[this.curLan].shareTitle,
								link: {
									mobileWebUrl: 'https://www.pandadagames.com/twitchdrops/',
									webUrl: 'https://www.pandadagames.com/twitchdrops/'
								}
							},
							{
								title: this.config[this.curLan].shareTitle,
								link: {
									mobileWebUrl: 'https://www.pandadagames.com/twitchdrops/',
									webUrl: 'https://www.pandadagames.com/twitchdrops/'
								}
							}
						]
					})
				}

				createButton({
					lan: 'tc',
					title: this.config['tc'].shareTitle,
					description: this.config['tc'].shareDesc,
					imageUrl: this.config['tc'].shareImg
				})
				createButton({
					lan: 'en',
					title: this.config['en'].shareTitle,
					description: this.config['en'].shareDesc,
					imageUrl: this.config['en'].shareImg
				})
				createButton({
					lan: 'ja',
					title: this.config['ja'].shareTitle,
					description: this.config['ja'].shareDesc,
					imageUrl: this.config['ja'].shareImg
				})
				createButton({
					lan: 'ko',
					title: this.config['ko'].shareTitle,
					description: this.config['ko'].shareDesc,
					imageUrl: this.config['ko'].shareImg
				})
			}
		}
	}
</script>
